var sortingList = {
'manual': jmsPfFilterConfig.label.sorting_featured,
'title-ascending': jmsPfFilterConfig.label.sorting_title_ascending,
'title-descending': jmsPfFilterConfig.label.sorting_title_descending,
'price-ascending': jmsPfFilterConfig.label.sorting_price_ascending,
'price-descending': jmsPfFilterConfig.label.sorting_price_descending,
'created-descending': jmsPfFilterConfig.label.sorting_date_descending,
'created-ascending': jmsPfFilterConfig.label.sorting_date_ascending,
};

$(document).ready(function() {


var dataAjax = '';
var total_filter = $('.jms-filter-group').length;


$('.jms-pf-filter-option-multi-opt').on('click', function(e) {


e.preventDefault();
var opt = $(this);

var data_id = opt.data('id');
var data_val = opt.data('value');
var task = 'getFilterResult';
var shop_domain = jmsPfFilterConfig.shop.domain;
var c_id = jmsPfFilterConfig.general.collection_id;
var callback = 'JMSPfFilterCallback';
var pf_parent = opt.data('parent-label').toLowerCase().replace(" ", "_");

//get parent label from option
var parent_label = handleVal(opt.data('parent-label'));
//get data filter
var data_filter = opt.data('data-filter');
var display_type = opt.parents('.jms-filter-' + data_filter).data('display-type');

/** Add css to opt */
if (display_type === 'checkbox' || display_type === 'list') {
if (opt.hasClass('selected')) {
opt.removeClass('selected');
} else {
opt.addClass('selected');
}
} else if (display_type === 'radio_box') {
var otherOpt = opt.parent().parent().parent().parent().find('.jms-pf-filter-option-multi-opt.selected');
otherOpt.not(this).removeClass('selected');
opt.toggleClass('selected');
}
/** end add css */


//get value of opt
if (display_type === 'checkbox' || display_type === 'list') {
if ($("#pf_filter_" + parent_label).val() == '')
var params = [];
else
var params = $("#pf_filter_" + parent_label).val().split(',');

var index = params.indexOf(data_val);
if (index > -1) {
params.splice(index, 1);
$("#pf_filter_" + parent_label).val(params.toString());
} else {
params.push(data_val);
$("#pf_filter_" + parent_label).val(params.toString());
}
} else if (display_type === 'radio_box') {
var pf_value = $("#pf_filter_" + parent_label).val();
if (pf_value === '')
var pf_val = data_val;
else {
if (pf_value === data_val)
var pf_val = '';
else
var pf_val = data_val;
}
$("#pf_filter_" + parent_label).val(pf_val);
}
var stateData = '';
$('.jms-filter-group').each(function(idx) {

var group_title = $(this).data('group-title');
var filter = $(this).data('data-filter');
if ($("#pf_filter_" + handleVal(group_title)).val() !== '') {
dataAjax += '&' + handleVal(filter) + '=' + $("#pf_filter_" + handleVal(group_title)).val();
var paramVal = $("#pf_filter_" + handleVal(group_title)).val();
stateData += '&' + handleVal(filter) + '=' + encodeURIComponent(paramVal);
}
});



var sortByVal = $('#sortByVal').val();
if (sortByVal) {
dataAjax += '&sort_by=' + sortByVal;
stateData += '&sort_by=' + sortByVal;
}


filterClear();
historyPushState(stateData);
sendAjax(dataAjax);
dataAjax = '';
});


});

function buildGridItemHtml(data, customerData) {
var onSale = data.compare_at_price_min > data.price_min;
var priceVaries = data.price_min !== data.price_max;
var salePriceLabel = jmsPfFilterTemplate.salePriceLabelHtml.replace(/{SALE_PRICE_LABEL}/g, jmsPfFilterConfig.label.sale_price);
var regularPriceLabel = jmsPfFilterTemplate.regularPriceLabelHtml.replace(/{REGULAR_PRICE_LABEL}/g, jmsPfFilterConfig.label.regular_price);

var itemHtml = jmsPfFilterTemplate.productGridItemHtml;

//add item img
var images = Object.keys(data.images).map(function(key) {
return data.images[key];
});
var imgThumbHtml = '';
if(images.length > 0) {
if(images.length > 1 && imageSwap == true) {
imgThumbHtml += '<img src="'+optimizeImg(images[0])+'" alt="'+data.title+'" class="first-image img-responsive">';
imgThumbHtml += '<img src="'+optimizeImg(images[1])+'" alt="'+data.title+'" class="second-img img-responsive">';
} else {
imgThumbHtml += '<img src="'+optimizeImg(images[0])+'" alt="'+data.title+'" class="img-responsive">';
}
} else {
imgThumbHtml += '<img src="'+optimizeImg(jmsPfFilterConfig.general.no_image_url)+'" alt="'+data.title+'" class="img-responsive">';
}
itemHtml = itemHtml.replace(/{DISPLAY_ITEM_THUMB}/g, imgThumbHtml);

itemHtml = itemHtml.replace(/{ITEM_URL}/g, buildProductItemUrl(data.handle));
itemHtml = itemHtml.replace(/{ITEM_TITLE}/g, data.title);

//PRICE
var saleLabel = jmsPfFilterTemplate.saleLabel.replace(/{SALE_LABEL}/g, jmsPfFilterConfig.label.sale);
var itemPriceHtml = '';
if (onSale) {
itemPriceHtml += regularPriceLabel.replace(/{REGULAR_PRICE}/g,formatMoneyProduct(data.compare_at_price_min));
itemPriceHtml += salePriceLabel.replace(/{SALE_PRICE}/g,formatMoneyProduct(data.price_min));
} else {
if (priceVaries) {
itemPriceHtml += salePriceLabel.replace(/{SALE_PRICE}/g,formatMoneyProduct(data.price_min));
} else {
itemPriceHtml += salePriceLabel.replace(/{SALE_PRICE}/g,formatMoneyProduct(data.price_min));
}
}

itemHtml = itemHtml.replace(/{DISPLAY_ITEM_PRICE}/g, itemPriceHtml);
itemHtml = itemHtml.replace(/{ITEM_VENDOR}/g, data.vendor);
itemHtml = itemHtml.replace(/{ITEM_PRODUCT_TYPE}/g, data.product_type);
//add product id : {ITEM_ID}
itemHtml = itemHtml.replace(/{ITEM_ID}/g, data.id);

//add product tags : {ITEM_TAGS}
itemHtml = itemHtml.replace(/{ITEM_TAGS}/g, data.tags.toLowerCase());

//add product created at : {ITEM_CREATED_AT}
var str = data.created_at;
var date = formatDate(str);
itemHtml = itemHtml.replace(/{ITEM_CREATED_AT}/g, date);

//add price min from all variant product: {ITEM_PRICE_MIN}
itemHtml = itemHtml.replace(/{ITEM_PRICE_MIN}/g, data.price_min);
//add compare price min from all variant product: {ITEM_COMPARE_AT_PRICE_MIN}
itemHtml = itemHtml.replace(/{ITEM_COMPARE_AT_PRICE_MIN}/g, data.compare_at_price_min);

//add product colors: {DISPLAY_ITEM_COLORS}
var colorHtml = '';
var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('mark.jpg'));
if(Object.keys(data.options_with_values).length > 0){
for (i in data.options_with_values) {
if(data.options_with_values[i].name == 'Color' || data.options_with_values[i].name == 'color') {
colorHtml += '<ul class="item-colors">';
    for(j in data.options_with_values[i].values) {
    colorHtml += '<li>';
        colorHtml += '<label style="background-color: '+data.options_with_values[i].values[j].toLowerCase()+'; background-image: url(' + assetUrl + data.options_with_values[i].values[j].toLowerCase() + '.jpg);"></label>';
        colorHtml += '</li>';
    }
    colorHtml += '</ul>';
}
}
}
itemHtml = itemHtml.replace(/{DISPLAY_ITEM_COLORS}/g, colorHtml);

//add ADD TO CART BUTTON TOOLTIP: {ADD_TO_CART_BUTTON_TOOLTIP}
var tooltip = '';
if(data.available == true) {
if(Object.keys(data.variants_with_id).length > 1){
tooltip = '<span class="tooltip">Choose Option</span>';
} else {
tooltip = '<span class="tooltip">Add to Cart</span>';
}
} else {
tooltip = '<span class="tooltip">Unavailable</span>';
}
itemHtml = itemHtml.replace(/{ADD_TO_CART_BUTTON_TOOLTIP}/g, tooltip);

//add ADD_TO_CART_BUTTON_ACTION_LABEL: {ADD_TO_CART_BUTTON_ACTION_LABEL}
var label = '';
if(data.available == true) {
if(Object.keys(data.variants_with_id).length > 1){
label = '<span>Choose Option</span>';
} else {
label = '<span>Add to Cart</span>';
}
} else {
label = '<span>Unavailable</span>';
}
itemHtml = itemHtml.replace(/{ADD_TO_CART_BUTTON_ACTION_LABEL}/g, label);

//add ADD TO CART BUTTON TOOLTIP: {ADD_TO_CART_BUTTON_TOOLTIP}
var action = '';
if(data.available == true) {
if(Object.keys(data.variants_with_id).length > 1){
action = '<input class="btn" type="button" onclick="window.location.href=\''+buildProductItemUrl(data.handle)+'\'" value="Choose Option" />';
} else {
action = '<input type="hidden" name="id" value="'+data.variants_with_id[0].id+'" />';
}
} else {
action = '<input class="btn add-to-cart-btn" type="submit" value="Unavailable" disabled />';
}
itemHtml = itemHtml.replace(/{ADD_TO_CART_BUTTON_ACTION}/g, action);


//add title handle: {ITEM_COMPARE_AT_PRICE_MIN}
itemHtml = itemHtml.replace(/{ITEM_HANDLE}/g, data.handle);
if(jmsPfFilterConfig.customer.customer_id != 0){
if(customerData.tags.indexOf(data.handle) >= 0){
itemHtml = itemHtml.replace(/{JMS_WISHLIST_EVENT}/g, "return false;");
itemHtml = itemHtml.replace(/icon icon-heart/g, "fa fa-check");
} else {
itemHtml = itemHtml.replace(/{JMS_WISHLIST_EVENT}/g, "jmsWishlistAddTag('"+data.handle.trim()+"',this)");
}

} else {
itemHtml = itemHtml.replace(/{JMS_WISHLIST_EVENT}/g, 'jmsToLoginPage()');
}

if(onSale) {
itemHtml = itemHtml.replace(/{DISPLAY_SALE_LABEL}/g, saleLabel);
} else {
itemHtml = itemHtml.replace(/{DISPLAY_SALE_LABEL}/g, '');
}
itemHtml = itemHtml.replace(/{ITEM_SHORT_DESC}/g, data.body_html.substring(0,200)+'...');
return itemHtml;
}

function formatDate(date) {
var d = new Date(date),
month = '' + (d.getMonth() + 1),
day = '' + d.getDate(),
year = d.getFullYear();

if (month.length < 2) month = '0' + month;
if (day.length < 2) day = '0' + day;

return [year, month, day].join('-');
}

function optimizeImg(imgSrc) {
var imgSrc = String(imgSrc);
var imageSize = jmsPfFilterConfig.general.image_size;
if (imageSize == 'master') {
var newImgSrc = imgSrc;
} else {
if (imgSrc.indexOf('.jpg') >= 0)
var newImgSrc = imgSrc.replace('.jpg', '_' + imageSize + '.jpg');
if (imgSrc.indexOf('.png') >= 0)
var newImgSrc = imgSrc.replace('.png', '_' + imageSize + '.png');
}

return newImgSrc;
}